import { User } from '../types/user';
import baseApi from './baseApi';

export interface OnboardingRequest {
  recaptchaToken: string;
  companyName: string;
  userName: string;
  email: string;
  password: string;
  phoneNumber: string;
}

export interface OnboardingResponse {
  message: string;
  user: User;
  company: {
    id: number;
    name: string;
  };
  businessUnit: {
    id: number;
    name: string;
    phoneNumber: string;
  };
}

const onboardingApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createOnboarding: build.mutation<OnboardingResponse, OnboardingRequest>({
      query: (data) => ({
        url: '/onboarding',
        method: 'POST',
        body: data,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useCreateOnboardingMutation } = onboardingApi;
export default onboardingApi;
